import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import {
  CaseInputWrapper,
  CaseDateWrapper,
  CaseCheckWrapper,
  CaseArrayInput,
  NestedObjectWrapper,
  NestedObjectWrapperWithKeyMapping,
  CaseTextAreaInput,
} from '.'
import { useTranslation } from 'react-i18next'

export const CaseInputSelector = ({ formField }) => {
  const { t } = useTranslation()
  return (
    <>
      {formField.type === 'input' && (
        <CaseInputWrapper
          width="100%"
          margin="0 24px 24px 24px"
          label={t(`caseFormSectionsLabels.${formField.label}`)}
          name={formField.key}
        />
      )}
      {formField.type === 'date' && (
        <CaseDateWrapper
          width="100%"
          margin="0 24px 24px 24px"
          label={t(`caseFormSectionsLabels.${formField.label}`)}
          name={formField.key}
        />
      )}
      {formField.type === 'check' && (
        <CaseCheckWrapper
          width="100%"
          margin="0 24px 24px 24px"
          label={t(`caseFormSectionsLabels.${formField.label}`)}
          type={formField.key}
        />
      )}
      {formField.type === 'array' && (
        <CaseArrayInput
          width="100%"
          margin="0 24px 24px 24px"
          type={formField.key}
          shortType={t(`caseFormSectionsLabels.${formField.shortLabel}`)}
          title={t(`caseFormSectionsLabels.${formField.label}`)}
        />
      )}
      {formField.type === 'textarea' && (
        <CaseTextAreaInput
          label={t(`caseFormSectionsLabels.${formField.label}`)}
          name={formField.key}
          margin="0 24px 24px 24px"
        />
      )}
      {formField.type === 'nestedArray' &&
        formField.typeKeys.map((type, index) => (
          <NestedObjectWrapper
            key={`${type}_${index}`}
            type={formField.key}
            shortType={type}
            title={t(`caseFormSectionsLabels.${type}`)}
            formField={formField}
            width="100%"
            margin="0 24px 24px 24px"
          />
        ))}
      {formField.type === 'blank' && (
        <Flex width="100%" key={`${formField.key}`} />
      )}
      {formField.type === 'sectionLabel' && (
        <Flex full>
          <Text size="16px" weight="600" margin="0 24px 24px 24px">
            {t(`caseFormSectionsLabels.${formField.label}`)}
          </Text>
        </Flex>
      )}
      {/* this is for arrays we do not know the 'type' of for all entries currently, only additionalFamily */}
      {formField.type === 'mappedArray' && (
        <NestedObjectWrapperWithKeyMapping
          formField={formField}
          width="100%"
          margin="0 24px 24px 24px"
        />
      )}
    </>
  )
}

export default CaseInputSelector
